module.exports = __webpack_public_path__ + "assets/img/index-partner22.917c164e.jpg";